import * as React from 'react';
import moment, {Moment} from 'moment';
import styled from 'styled-components';
import {getDaysCountFromMs} from './CoursePromo/helpers';

export interface CountdownProps {
  timeTillDate: Moment;
}

type Value = string | number;

interface CountDownState {
  days: Value,
  hours: Value,
  minutes: Value,
  seconds: Value,
}

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
`;

/**
 * format countdown value
 * @param {number} value
 * @return {string}
 */
function formatValue(value: number) {
  const intValue = Math.floor(value);
  const strValue = String(intValue);

  return strValue.padStart(2, '0' );
}

/**
 * The countdown component
 * @param {Moment} timeTillDate
 * @return {React.ReactElement}
 * @constructor
 */
export function Countdown({
  timeTillDate,
}: CountdownProps) {
  const [state, setState] = React.useState<CountDownState>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  /**
   * prepare and set countdown values
   * @return {void}
   */
  function setCountdownValues() {
    const end: Moment = timeTillDate;
    const now: Moment = moment();

    const diff: number = now.diff(end) * -1;

    const days = getDaysCountFromMs(diff);
    const hours = (days * 24) % 24;
    const minutes = (hours * 60) % 60;
    const seconds = (minutes * 60) % 60;

    setState({
      days: Math.floor(days),
      hours: formatValue(hours),
      minutes: formatValue(minutes),
      seconds: formatValue(seconds),
    });
  }

  React.useEffect(() => {
    setCountdownValues();
    const interval = setInterval(setCountdownValues, 1000);
    return () => clearInterval(interval);
  }, [timeTillDate]);

  const {
    days,
    hours,
    minutes,
    seconds,
  } = state;

  return (
    <Wrapper>
      {days > 0 && (
        <Item>
          {days}
          <span>
          &nbsp;
          дня
          &nbsp;
          </span>
        </Item>
      )}
      <Item>
        {hours}
        <span>:</span>
      </Item>
      <Item>
        {minutes}
        <span>:</span>
      </Item>
      <Item>
        {seconds}
      </Item>
    </Wrapper>
  );
}
